<div class="flex-grid align-items-center">
  <input
    class="value-field p-2 col"
    type="text"
    readonly
    [ngModel]="value"
  >
  <div class="col-auto ps-4">
    <sk-button color="primary"
               data-test="copy-to-clipboard-button"
               size="m"
               [label]="buttonLabel | translate"
               (click)="copyToClipboard()"
               data-test="copy-field-button">
    </sk-button>
  </div>
</div>
